import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ToneAudioNode } from "../../core/context/ToneAudioNode";
import { optionsFromArguments } from "../../core/util/Defaults";
/**
 * Split splits an incoming signal into the number of given channels.
 *
 * @example
 * const split = new Tone.Split();
 * // stereoSignal.connect(split);
 * @category Component
 */
export var Split = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(Split, _ToneAudioNode);
  function Split() {
    var _this;
    _classCallCheck(this, Split);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Split).call(this, optionsFromArguments(Split.getDefaults(), arguments, ["channels"])));
    _this.name = "Split";
    var options = optionsFromArguments(Split.getDefaults(), arguments, ["channels"]);
    _this._splitter = _this.input = _this.output = _this.context.createChannelSplitter(options.channels);
    _this._internalChannels = [_this._splitter];
    return _this;
  }
  _createClass(Split, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Split.prototype), "dispose", this).call(this);
      this._splitter.disconnect();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        channels: 2
      });
    }
  }]);
  return Split;
}(ToneAudioNode);